/*
 * JUNGCARDS effects (assets/jc-polish.css). Each part only runs when its class is on <html>
 * (Theme settings > JUNGCARDS > Effects) and, for motion, without prefers-reduced-motion.
 */
(function () {
  if (window.jcFxReady) return;
  window.jcFxReady = true;

  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var has = function (name) { return root.classList.contains(name); };
  var parts = [];

  /* PARTS */

  /* ---- Hero depth: pointer parallax, eased toward the target each frame ---- */
  parts.push(function heroParallax() {
    if (!has('jc-fx-depth') || reduceMotion || !finePointer) return;
    document.querySelectorAll('.jc-hero').forEach(function (hero) {
      var target = { x: 0, y: 0 };
      var current = { x: 0, y: 0 };
      var frame = null;
      var media = null;

      function tick() {
        current.x += (target.x - current.x) * 0.06;
        current.y += (target.y - current.y) * 0.06;
        if (media) {
          media.style.setProperty('--jc-px', current.x.toFixed(3));
          media.style.setProperty('--jc-py', current.y.toFixed(3));
        }
        if (Math.abs(target.x - current.x) > 0.002 || Math.abs(target.y - current.y) > 0.002) {
          frame = requestAnimationFrame(tick);
        } else {
          frame = null;
        }
      }

      function kick() {
        if (!frame) frame = requestAnimationFrame(tick);
      }

      hero.addEventListener('pointermove', function (event) {
        var rect = hero.getBoundingClientRect();
        target.x = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
        target.y = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
        var active = hero.querySelector('.jc-hero__slide.is-active .jc-hero__media');
        if (active !== media) {
          if (media) { media.style.removeProperty('--jc-px'); media.style.removeProperty('--jc-py'); }
          media = active;
        }
        kick();
      }, { passive: true });

      hero.addEventListener('pointerleave', function () {
        target.x = 0;
        target.y = 0;
        kick();
      });
    });
  });

  /* ---- Holo foil: pointer position and tilt for foil cards (delegated, one listener) ---- */
  parts.push(function foil() {
    if (!has('jc-fx-foil') || !finePointer) return;
    var active = null;
    var pending = null;
    var last = null;
    var props = ['--jc-mx', '--jc-my', '--jc-rx', '--jc-ry'];

    function apply() {
      pending = null;
      if (!active || !last) return;
      var rect = active.getBoundingClientRect();
      var x = Math.min(Math.max((last.clientX - rect.left) / rect.width, 0), 1);
      var y = Math.min(Math.max((last.clientY - rect.top) / rect.height, 0), 1);
      active.style.setProperty('--jc-mx', (x * 100).toFixed(1) + '%');
      active.style.setProperty('--jc-my', (y * 100).toFixed(1) + '%');
      if (!reduceMotion) {
        active.style.setProperty('--jc-rx', ((x - 0.5) * 10).toFixed(2) + 'deg');
        active.style.setProperty('--jc-ry', ((0.5 - y) * 10).toFixed(2) + 'deg');
      }
    }

    document.addEventListener('pointermove', function (event) {
      var media = event.target.closest ? event.target.closest('.jc-card--foil .jc-card__media') : null;
      if (media !== active) {
        if (active) props.forEach(function (p) { active.style.removeProperty(p); });
        active = media;
      }
      if (!active) return;
      last = event;
      if (!pending) pending = requestAnimationFrame(apply);
    }, { passive: true });
  });


  /* ---- Marquee: only runs while on screen (an endless animation off screen still costs frames) ---- */
  parts.push(function marqueeInView() {
    var bands = document.querySelectorAll('.jc-marquee');
    if (!bands.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('is-inview', entry.isIntersecting);
      });
    });
    bands.forEach(function (band) { io.observe(band); });
    root.classList.add('jc-io');
  });


  /* ---- Loading shimmer: mark product image containers once their image has loaded ---- */
  parts.push(function skeleton() {
    if (!has('jc-fx-skel')) return;

    function mark(img) {
      var box = img.closest('.jc-card__media');
      if (box) box.classList.add('is-loaded');
    }

    function scan(scope) {
      scope.querySelectorAll('.jc-card__media:not(.is-loaded)').forEach(function (box) {
        var img = box.querySelector('img');
        if (!img || (img.complete && img.naturalWidth > 0)) box.classList.add('is-loaded');
      });
    }

    // load/error do not bubble: listen in the capture phase, so cards added later count too.
    document.addEventListener('load', function (event) {
      if (event.target.tagName === 'IMG') mark(event.target);
    }, true);
    document.addEventListener('error', function (event) {
      if (event.target.tagName === 'IMG') mark(event.target);
    }, true);

    scan(document);
    root.classList.add('jc-skel-on');
    // Cards rendered by scripts (recommendations, quick add) after start-up.
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; scan(document); });
    }).observe(document.body, { childList: true, subtree: true });
  });


  /* ---- Cart count: bump only when the number goes up (header bubble + bottom nav) ---- */
  parts.push(function cartBump() {
    function count(el) {
      var n = parseInt((el && el.textContent) || '0', 10);
      return isNaN(n) ? 0 : n;
    }

    function bump(el) {
      if (!el || reduceMotion) return;
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
    }

    var icon = document.getElementById('cart-icon-bubble');
    if (icon) {
      var bubbleCount = function () { return count(icon.querySelector('.cart-count-bubble span[aria-hidden="true"]') || icon.querySelector('.cart-count-bubble')); };
      var lastHeader = bubbleCount();
      new MutationObserver(function () {
        var now = bubbleCount();
        if (now > lastHeader) {
          bump(icon.querySelector('.cart-count-bubble'));
          bump(icon);
        }
        lastHeader = now;
      }).observe(icon, { childList: true, subtree: true, characterData: true });
    }

    var navCount = document.querySelector('[data-jc-cart-count]');
    if (navCount) {
      var lastNav = count(navCount);
      new MutationObserver(function () {
        var now = count(navCount);
        if (now > lastNav) bump(navCount);
        lastNav = now;
      }).observe(navCount, { childList: true, subtree: true, characterData: true });
    }
  });

  /* ---- Add to cart on desktop: the product image flies to the cart icon ---- */
  parts.push(function flyToCart() {
    if (!has('jc-fx-fly') || reduceMotion || !finePointer || !Element.prototype.animate) return;
    var desktop = window.matchMedia('(min-width: 990px)');

    function sourceImage(from) {
      var card = from.closest('.jc-card');
      if (card) return card.querySelector('.jc-card__img');
      var addon = from.closest('.jc-addon');
      if (addon) return addon.querySelector('img');
      if (from.closest('product-info, .product')) {
        return document.querySelector('.product__media-item.is-active img') ||
          document.querySelector('.product__media-list .product__media img');
      }
      return null;
    }

    function fly(from) {
      if (!desktop.matches) return;
      var img = sourceImage(from);
      var target = document.querySelector('#cart-icon-bubble svg') || document.getElementById('cart-icon-bubble');
      if (!img || !target || !img.currentSrc) return;
      var a = img.getBoundingClientRect();
      var b = target.getBoundingClientRect();
      if (!a.width || a.bottom < 0 || a.top > window.innerHeight) return;

      var size = Math.min(a.width, a.height, 220);
      var startX = a.left + a.width / 2 - size / 2;
      var startY = a.top + a.height / 2 - size / 2;
      var dx = b.left + b.width / 2 - (startX + size / 2);
      var dy = b.top + b.height / 2 - (startY + size / 2);

      var clone = document.createElement('img');
      clone.src = img.currentSrc;
      clone.alt = '';
      clone.setAttribute('aria-hidden', 'true');
      clone.className = 'jc-fly';
      clone.style.cssText = 'left:' + startX + 'px;top:' + startY + 'px;width:' + size + 'px;height:' + size + 'px;';
      document.body.appendChild(clone);

      var animation = clone.animate(
        [
          { transform: 'translate(0, 0) scale(1)', opacity: 1 },
          { transform: 'translate(' + dx * 0.45 + 'px, ' + (dy * 0.45 - 90) + 'px) scale(0.55)', opacity: 1, offset: 0.45 },
          { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(0.08)', opacity: 0.35 }
        ],
        { duration: 760, easing: 'cubic-bezier(0.45, 0, 0.25, 1)' }
      );
      animation.onfinish = animation.oncancel = function () {
        clone.remove();
        var icon = document.getElementById('cart-icon-bubble');
        if (icon) {
          icon.classList.remove('is-bump');
          void icon.offsetWidth;
          icon.classList.add('is-bump');
        }
      };
    }

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (form && form.matches && form.matches('form[data-type="add-to-cart-form"]')) fly(form);
    }, true);
    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-jc-addon-add]');
      if (button) fly(button);
    }, true);
  });


  function init() {
    parts.forEach(function (part) {
      try { part(); } catch (e) { console.error('[jc-fx]', e); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
